import 'styled-components';
import { useLayoutEffect, useMemo } from 'react';
import { usePageTitle } from '@/hooks/usePageTitle.ts';
import { Col, Row, Text } from '@keyslabor/shared/ui';
import { FlagSpain, FlagUsa } from '@/assets/index';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { Language } from '@/api/types';
import { useApplyJobDetails } from '@/api/services.ts';
import LayoutContainer from '@/components/LayoutPageMobile/LayoutContainer.tsx';
import { routes } from '@/constants.ts';
import { useAppLanguage } from '@/hooks/useAppLanguage.ts';
import { css } from 'styled-components';

const useAvailableLanguages = () => {
  const params = useParams<{property_id: string}>();

  const { data: jobDetails } = useApplyJobDetails(params.property_id || '');

  return useMemo<Language[]>(() => {
    if (!jobDetails) return [];

    const languages: Language[] = [
      ...new Set(
        jobDetails.positions
          .map((position) => {
            return position.languages;
          })
          .flat()
      ),
    ];
    if (languages.length === 0) {
      return ['english'];
    }
    return languages;
  }, [jobDetails]);
}

function Welcome() {
  const [, setLanguage] = useAppLanguage();
  const params = useParams<{property_id: string}>();
  const { data: jobDetails } = useApplyJobDetails(params.property_id || '');

  usePageTitle(jobDetails?.client_name, 'apply');

  const availableLanguages = useAvailableLanguages();

  const isEngAvailable = availableLanguages.includes('english');
  const isSpanishAvailable = availableLanguages.includes('spanish');
  const isRussianAvailable = availableLanguages.includes('russian');

  const navigate = useNavigate();

  const handleNext = (language: Language) => {
    setLanguage(language);
    navigate(generatePath(routes.applyForm, {
      property_id: params.property_id || '',
    }));
  };

  useLayoutEffect(() => {
    if ( availableLanguages.length === 1) {
      handleNext(availableLanguages[0]);
    }
  }, [availableLanguages]);

  return (
    <LayoutContainer
      pb="20px"
      css={css`
        & {
          min-height: 100vh;
          min-height: 100dvh;
            background-image: url('/lang_bg.png');
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
        }
      `}
    >
      <Row flexCenter>
        <Text
          fontWeight="800"
          fontSize="18px"
          maxWidth="220px"
          upper
          center
          mt="40px"
        >
          Please select
          interview language
        </Text>

        <Col gap="60px" mt="40px">
          {isEngAvailable && (
            <Row
              gap="20px"
              flexCenter
              css="cursor: pointer;"
              onClick={() => handleNext('english')}
            >
              <FlagUsa />
              <Text fontWeight="800" fontSize="18px" upper>
                English
              </Text>
            </Row>
          )}
          {isSpanishAvailable && (
            <Row
              gap="20px"
              flexCenter
              onClick={() => handleNext('spanish')}
              css="cursor: pointer;"
            >
              <FlagSpain />
              <Text fontWeight="800" fontSize="18px" upper>
                Español
              </Text>
            </Row>
          )}
        </Col>
        {isRussianAvailable && (
          <Col gap="60px" mt="60px">
              <Row
                gap="20px"
                flexCenter
                css="cursor: pointer;"
                onClick={() => handleNext('russian')}
              >
                <Text fontWeight="800" fontSize="14px" upper>
                  Русский
                </Text>
              </Row>
          </Col>
        )}
      </Row>
    </LayoutContainer>
  );
}

export default Welcome;
